import * as _ from "lodash";
import { assetSeparator } from "./create-module";

/**
 * Make a unique asset from anything
 * @param copyKey
 * @param identity
 * @param rest
 */
export const makeAsset = (copyKey: string, identity: string, ...rest: string[]): string => {
  const convertedIdentity = _.upperFirst(_.camelCase(identity));

  return `${copyKey}-${convertedIdentity || identity}${
    rest.length ? `#${_.join(_.map(rest, _.camelCase), assetSeparator)}` : ""
  }`;
};
